module.exports = __webpack_public_path__ + "static/media/pk_button.b225d809.jpg";